import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import { printA4 } from './utils/invoicePrint'
import './registerServiceWorker' // 이 줄이 있는지 확인하세요. (Vite 코드 대신 사용)

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './registerServiceWorker'

Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.prototype.$printA4 = printA4;

new Vue({
    router,
    render: h => h(App),
}).$mount('#app')
